export default __webpack_public_path__ + "locales/sq-AL/InfoPanel.json?hash=31c6cdf96dfb9bb9b226358c02bc1999";